import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import badge from "../../img/assets/badge.png";
import "./leaderboardScreen.css";
import { selectAdminToken } from "../../admin/sessionSlice";
import { gameGetState } from "../../admin/functions/gameApi";

function formatPoints(raw) {
  const n = Number(raw);
  if (!Number.isFinite(n)) return String(raw ?? "—");
  return n.toLocaleString(undefined, { maximumFractionDigits: 0 });
}

export default function LeaderboardScreen() {
  const navigate = useNavigate();
  const token = useSelector(selectAdminToken);
  const themeFromStore = useSelector((state) => state.theme?.currentTheme);
  const currentTheme = themeFromStore || localStorage.getItem("currentTheme");
  const prevLeaderboardVisibleRef = useRef(null);

  const [rows, setRows] = useState([]);
  const [sessionState, setSessionState] = useState(null);

  useEffect(() => {
    if (!token || !currentTheme) return undefined;
    let cancelled = false;

    async function poll() {
      try {
        const data = await gameGetState({ token, currentTheme });
        if (cancelled || !data.success) return;
        setRows(Array.isArray(data.leaderboard) ? data.leaderboard : []);
        setSessionState(data.state || null);
      } catch {
        /* ignore */
      }
    }

    poll();
    const interval = window.setInterval(poll, 1000);
    return () => {
      cancelled = true;
      window.clearInterval(interval);
    };
  }, [token, currentTheme]);

  useEffect(() => {
    if (!token || !currentTheme || sessionState == null) return;
    const raw = sessionState.leaderboard_visible;
    const lb = raw != null && raw !== "" ? Number(raw) : null;
    if (lb == null || !Number.isFinite(lb)) return;
    const prev = prevLeaderboardVisibleRef.current;
    if (prev === 1 && lb === 0) {
      navigate("/question");
    }
    prevLeaderboardVisibleRef.current = lb;
  }, [token, currentTheme, sessionState, navigate]);

  if (!token || !currentTheme) {
    return (
      <main className="leaderboard-screen leaderboard-screen--waiting">
        <p className="leaderboard-screen__waiting-msg">Sign in and select a theme to view the leaderboard.</p>
      </main>
    );
  }

  return (
    <main className="leaderboard-screen">
      <section className="leaderboard-card">
        <header className="leaderboard-title">
          <img src={badge} alt="" aria-hidden className="leaderboard-title__badge" />
          <h1>LEADERBOARD</h1>
          <img src={badge} alt="" aria-hidden className="leaderboard-title__badge" />
        </header>

        <div className="leaderboard-table-wrap">
          <div className="leaderboard-grid leaderboard-grid--header">
            <span>RANK</span>
            <span>NAME</span>
            <span>POINTS</span>
          </div>

          <div className="leaderboard-rows">
            {rows.length === 0 ? (
              <div className="leaderboard-grid leaderboard-grid--row leaderboard-grid--empty">
                <span>—</span>
                <span>No scores yet</span>
                <span>—</span>
              </div>
            ) : (
              rows.map((row, index) => (
                <div className="leaderboard-grid leaderboard-grid--row" key={row.player_id}>
                  <span>#{index + 1}</span>
                  <span>{row.player_name}</span>
                  <span>{formatPoints(row.points)}</span>
                </div>
              ))
            )}
          </div>
        </div>
      </section>
    </main>
  );
}
